import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TrackingScripts from "../components/TrackingScripts";
import { buildVersion } from "../services/buildInfo";

import "./thankyou.css"

function Thankyou() {
    const [showSection, setThankYou] = useState(false);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/");
    };

    useEffect(() => {
        const type = localStorage.getItem("type");
        setThankYou(type);
    }, []);

    // Adobe DataLayer (KEPT)
    useEffect(() => {
        window.adobeDataLayer = window.adobeDataLayer || [];
        window.adobeDataLayer.push({
            "event": "pageView",
            "web": {
                "webPageDetails": {
                    "pageViews": {
                        "value": 1
                    },
                    "name": "icicibank:in:en:campaign:accounts:casa:salcorpsavingsaccount:onboarding:eligible thankyou page",
                    "URL": window.location.href,
                    "isErrorPage": "False",
                }
            },
            "_icicibank": {
                "channelInfo": {
                    "version": buildVersion,
                    "name": "nli",
                },
                "pageInfo": {
                    "language": "en",
                    "country": "in",
                    "pageType": "campaign",
                    "virtualPageView": "no vpv",
                    "journey": "na",
                    "subJourney": "na",
                    "subSubJourney": "na",
                },
                "userInfo": {
                    "userType": "na"
                },
                "errorInfo": {
                    "errorType": "na",
                    "errorDetails": "na"
                }
            }
        });
    }, []);


    return (
        <>
            <TrackingScripts />
            <section className="thank-you">
                <div className="container">
                    <div className="thank-you">
                        <div className="margin-top" style={{ position: "relative" }}>
                            {/* <h2 className="">
                                Thank you for choosing ICICI Bank
                            </h2> */}
                            <div className="popup-icon">
                                <img src="../dist/img/icon15.webp" width="89" height="84" alt="Thanks" />
                            </div>
                            <div className="thankyou_txt">
                                <h3>
                                    Thank you for your interest in the ICICI 3-in-1 Salary Account. Your submission is complete.
                                </h3>
                                <h3>
                                    We are currently reviewing your details to ensure we provide you with the most relevant options for your profile.
                                </h3>
                                <h3>
                                    If applicable, one of our Relationship Managers will contact you shortly to take things forward.
                                </h3>
                            </div>
                            {/* <h3>Our representative will <br />
                                get in touch with you shortly <br />
                                from a number starting with <br /> <span>1600 31 XXXX.</span></h3> */}

                            <button href="/" onClick={handleClick} className="free_back thank_you_back">
                                Go back
                            </button>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
}

export default Thankyou;